// extracted by mini-css-extract-plugin
export default {"content":"replace-storage-confirmation_content__5vUE3"};